export default "__VITE_ASSET__DoWEnEk0__"